/**
 * Handles submission for the home contact form with AJAX feedback.
 */
export const initHomeContactForm = (): void => {
  // Find the form within any home contact section on the page
  const form = document.querySelector<HTMLFormElement>(
    ".app-home-contact-form"
  );
  if (!form) {
    // No form on this page, so we exit silently.
    return;
  }

  const ajaxMessageContainer =
    form.querySelector<HTMLDivElement>(".ajax-message");
  if (!ajaxMessageContainer) {
    console.warn("[Home Contact Form] AJAX message container not found.");
    return;
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const submitButton = form.querySelector<HTMLButtonElement>(
      'button[type="submit"]'
    );
    if (!submitButton) return;

    // Clear previous messages and disable the button to prevent double submission
    ajaxMessageContainer.innerHTML = "";
    ajaxMessageContainer.classList.remove("error", "success");
    submitButton.disabled = true;
    submitButton.style.opacity = "0.7";

    const formData = new FormData(form);
    formData.append("action", "submit_home_contact_form");

    // Append the localized nonce
    if (window.themeVariables && window.themeVariables.homeContactFormNonce) {
      formData.append(
        "homeContactFormNonce",
        window.themeVariables.homeContactFormNonce
      );
    } else {
      console.error("Home contact form nonce not found.");
      ajaxMessageContainer.innerHTML = `<div class="alert alert-danger">A configuration error occurred. Please contact support.</div>`;
      submitButton.disabled = false;
      submitButton.style.opacity = "1";
      return;
    }

    try {
      const response = await fetch(window.themeVariables.ajaxUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        ajaxMessageContainer.innerHTML = `<div class="alert alert-success">${result.data.message}</div>`;
        ajaxMessageContainer.classList.add("success");
        form.reset();

        const niceSelect = form.querySelector(".nice-select");
        if (niceSelect) {
          const select = form.querySelector("select");
          if (select) {
            select.selectedIndex = 0;
            // @ts-ignore
            if (typeof jQuery !== "undefined" && jQuery.fn.niceSelect) {
              // @ts-ignore
              jQuery(select).niceSelect("update");
            }
          }
        }
      } else {
        ajaxMessageContainer.innerHTML = `<div class="alert alert-danger">${result.data.message}</div>`;
        ajaxMessageContainer.classList.add("error");
      }
    } catch (error) {
      console.error("Home contact form submission error:", error);
      ajaxMessageContainer.innerHTML = `<div class="alert alert-danger">An unexpected error occurred. Please try again.</div>`;
      ajaxMessageContainer.classList.add("error");
    } finally {
      submitButton.disabled = false;
      submitButton.style.opacity = "1";
    }
  });

  console.log("[Forms] Home Contact Form initialized.");
};
